var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rowdata)?[(_vm.inputs)?[_c('TableItemVue',{attrs:{"input":_vm.inputs,"type":_vm.inputs.component.name,"rowdata":_vm.rowdata,"rowall":_vm.rowall}})]:[_vm._v(_vm._s(_vm.rowdata))]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }